export const REFERRAL_CODE = 'referral_code';
export const TOKEN_EVENT_SENT = 'token_event_sent';
export const CART_SUGGESTION_TOKEN_EVENT_SENT = 'cart_suggestion_token_event_sent';
export const SESSION_ID = 'sessionId';
export const UTM_SOURCE = 'utm_source';
export const UTM_MEDIUM = 'utm_medium';
export const UTM_CAMPAIGN = 'utm_campaign';
export const UTM_TERM = 'utm_term';
export const UTM_CONTENT = 'utm_content';
export const REFERRER = 'referrer';
